import React from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Home, Search, Plus, MessageSquareText, CircleUserRound } from 'lucide-react'

const BottomNav = () => {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const { userInfo } = useSelector(state => state.auth)

  const isActive = (path) => pathname === path
  const isChatActive = pathname.startsWith('/dashboard/chat')
  const isProfileActive = pathname.startsWith('/dashboard') && !isChatActive

  const handleMessages = () => navigate(userInfo ? '/dashboard/chat' : '/login')
  const handleProfile = () => navigate(userInfo ? '/dashboard' : '/login')
  const handlePost = () => {
    window.location.href = process.env.REACT_APP_SELLER_DASHBOARD_URL || '#'
  }

  const NAV_ITEMS = [
    {
      label: 'Home',
      icon: Home,
      active: isActive('/'),
      action: () => navigate('/'),
      isLink: true,
      to: '/',
    },
    {
      label: 'Explore',
      icon: Search,
      active: isActive('/products'),
      action: () => navigate('/products?category='),
      isLink: true,
      to: '/products?category=',
    },
    { label: 'Sell', center: true },
    {
      label: 'Messages',
      icon: MessageSquareText,
      active: isChatActive,
      action: handleMessages,
    },
    {
      label: 'Profile',
      icon: CircleUserRound,
      active: isProfileActive,
      action: handleProfile,
    },
  ]

  return (
    <div className="hidden md-lg:block fixed bottom-0 left-0 w-full z-50">
      {/* Frosted glass background */}
      <div className="bg-white/80 backdrop-blur-xl border-t border-gray-200/60 shadow-[0_-1px_20px_rgba(0,0,0,0.06)]">
        <div className="flex justify-around items-end px-2 pt-1.5 pb-safe max-w-lg mx-auto relative">

          {NAV_ITEMS.map((item) => {
            if (item.center) {
              return (
                <button
                  key="sell"
                  onClick={handlePost}
                  className="relative -mt-5 flex flex-col items-center"
                  aria-label="Post a listing"
                >
                  {/* Skeuomorphic raised Sell button */}
                  <div
                    className="w-[52px] h-[52px] rounded-2xl flex items-center justify-center text-white"
                    style={{
                      background: 'linear-gradient(145deg, #ff5252, #d32f2f)',
                      boxShadow: '0 4px 12px rgba(211,47,47,0.4), inset 0 1px 1px rgba(255,255,255,0.25), inset 0 -1px 1px rgba(0,0,0,0.1)',
                    }}
                  >
                    <Plus size={26} strokeWidth={2.5} />
                  </div>
                  <span className="text-[10px] font-semibold text-gray-500 mt-1">Sell</span>
                </button>
              )
            }

            const Icon = item.icon
            const active = item.active

            const content = (
              <div className="flex flex-col items-center gap-0.5 py-1 min-w-[48px]">
                <div className="relative">
                  <Icon
                    size={22}
                    strokeWidth={active ? 2.2 : 1.6}
                    className={`transition-colors ${active ? 'text-[#00A651]' : 'text-gray-400'}`}
                    fill={active && item.label === 'Home' ? '#00A651' : 'none'}
                  />
                  {/* Active dot indicator */}
                  {active && (
                    <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-[#00A651]" />
                  )}
                </div>
                <span className={`text-[10px] font-medium transition-colors ${active ? 'text-[#00A651]' : 'text-gray-400'}`}>
                  {item.label}
                </span>
              </div>
            )

            if (item.isLink) {
              return (
                <Link key={item.label} to={item.to} className="flex flex-col items-center">
                  {content}
                </Link>
              )
            }

            return (
              <button key={item.label} onClick={item.action} className="flex flex-col items-center">
                {content}
              </button>
            )
          })}

        </div>
      </div>
    </div>
  )
}

export default BottomNav
